<template>
    <div class="edit-account">
        <template v-if="owner.user">
            <div class="account-who">
                <span class="account-name">
                    {{ full_name(owner.user) }}
                    <span v-if="!owner.user.is_active" class="account-badge">Inactive</span>
                </span>
                <span class="account-login">{{ owner.user.username }}</span>
            </div>
            <button type="button" @click.stop="open_user()">
                <span class="material-symbols-outlined">manage_accounts</span>
                Edit user &amp; password
            </button>
        </template>
        <span v-else class="account-login">No user account is linked.</span>
    </div>


    <EditUser v-if="user" :user="user" @saved="refresh_owner()" @close="user=null"/>
</template>


<script setup>

    import {ref} from 'vue'
    import axios from 'axios'
    import EditUser from '@/components/edit/EditUser.vue'
    import {full_name} from '@/components/edit/helpers.js'

    const props=defineProps({
        owner:{type:Object,required:true},     // the instructor or student this user belongs to
    })

    let user=ref(null)


    // A fresh read rather than owner.user: the window edits exactly what the server serves for
    // a User, not the copy nested inside the instructor/student row.
    async function open_user(){
        try{
            let response=await axios.post('/admin/get_object/',{object:{endpoint:'User',id:props.owner.user.id}})
            user.value=response.data
        }catch(e){
            alert('Could not open this user. Try again.')
        }
    }


    // Names and the active flag live on the user. Re-read the owner so its row in the list
    // (and the window behind this one) shows the change.
    async function refresh_owner(){
        let response=await axios.post('/admin/get_object/',{object:{endpoint:props.owner.endpoint,id:props.owner.id}})
        Object.assign(props.owner,response.data)
    }

</script>


<style scoped>

    .edit-account{
        grid-column:1 / -1;
        display:flex;
        flex-wrap:wrap;
        align-items:center;
        justify-content:space-between;
        gap:10px 16px;
    }

    .account-who{
        display:flex;
        flex-direction:column;
        gap:2px;
        min-width:0;
    }

    .account-name{
        font-size:15px;
        font-weight:600;
    }

    .account-login{
        font-size:12.5px;
        color:var(--ew-muted);
    }

    .account-badge{
        margin-left:6px;
        padding:1px 8px;
        font-size:11px;
        font-weight:500;
        vertical-align:middle;
        color:var(--ew-muted);
        background:#efece7;
        border-radius:999px;
    }

    button{
        display:inline-flex;
        align-items:center;
        gap:6px;
        padding:7px 12px;
        font-size:13px;
        word-break:normal;
        color:var(--ew-text);
        background:#ffffff;
        border:1px solid var(--ew-field-line);
        border-radius:6px;
        box-shadow:none;
    }

    button:hover{
        color:var(--ew-text);
        background:var(--ew-bg);
        box-shadow:none;
    }

    button .material-symbols-outlined{
        font-size:18px;
    }

    button:disabled{
        opacity:.55;
        cursor:default;
    }

</style>
